import Vue from "vue";

const END_POINT = "/account";

const getAccountRoles = async () => {
  return await Vue.axios.get(END_POINT + "/get-roles").then((resp) => {
    return resp.data;
  });
};

const getActiveUsers = () => Vue.axios.get(END_POINT + "/jwt/active");

const removeActiveUser = (id) =>
  Vue.axios.delete(END_POINT + "/jwt/delete/" + id);

const getAccount = async () => {
  const res = await Vue.axios.get("/account/get-my-account");
  return res.data;
};

const getAccountDashboardConfig = async (id) => {
  const res = await Vue.axios.get(`/account/${id}/default-dashboard-config`);
  return res.data;
};

const updateAccountDashboardConfig = async (id, payload) => {
  const res = await Vue.axios.put(
    `/account/${id}/default-dashboard-config`,
    payload,
  );
  return res.data;
};

// Phase 5: per-tenant reminder pipeline config.
const getReminderConfig = async (accountId) => {
  const res = await Vue.axios.get(`/account/${accountId}/reminder-config`);
  return res.data;
};

const updateReminderConfig = async (accountId, payload) => {
  const res = await Vue.axios.put(
    `/account/${accountId}/reminder-config`,
    payload,
  );
  return res.data;
};

// Phase 5: per-tenant Meet auto-generate config.
const getMeetConfig = async (accountId) => {
  const res = await Vue.axios.get(`/account/${accountId}/meet-config`);
  return res.data;
};

const updateMeetConfig = async (accountId, payload) => {
  const res = await Vue.axios.put(`/account/${accountId}/meet-config`, payload);
  return res.data;
};

// Phase 5 follow-up: Google Workspace service-account credentials.
const getGoogleCredentialsStatus = async (accountId) => {
  const res = await Vue.axios.get(
    `/account/${accountId}/google-credentials/status`,
  );
  return res.data;
};

const uploadGoogleCredentials = async (accountId, credentialsJson) => {
  const res = await Vue.axios.patch(
    `/account/${accountId}/google-credentials`,
    { credentials: credentialsJson },
  );
  return res.data;
};

export {
  getAccountRoles,
  getActiveUsers,
  removeActiveUser,
  getAccount,
  getAccountDashboardConfig,
  updateAccountDashboardConfig,
  getReminderConfig,
  updateReminderConfig,
  getMeetConfig,
  updateMeetConfig,
  getGoogleCredentialsStatus,
  uploadGoogleCredentials,
};
